import React from 'react';
import { useAuthStore } from '../store/authStore';

const Profile: React.FC = () => {
  const { user } = useAuthStore();

  if (!user) return null;

  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-6">Profile Settings</h1>
        <div className="text-center py-12">
          <div className="text-4xl mb-4">🚧</div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">Coming Soon</h3>
          <p className="text-gray-600 dark:text-gray-300">
            Profile management features are being built. This will include account settings,
            billing information, and preferences.
          </p>
          <div className="mt-6 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg max-w-sm mx-auto">
            <h4 className="font-medium text-gray-900 dark:text-gray-100 mb-2">Current Account</h4>
            <div className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
              <p><strong>Name:</strong> {user.name}</p>
              <p><strong>Email:</strong> {user.email}</p>
              <p><strong>Total Spent:</strong> ${(user.total_spent || 0).toFixed(2)}</p>
              <p><strong>Member since:</strong> {new Date(user.created_at).toLocaleDateString()}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
